import { useQuery } from '@tanstack/react-query';

export const useGitHubStars = (repo: string) => {
  return useQuery({
    queryKey: ['github-stars', repo],
    queryFn: async () => {
      const res = await fetch(`https://api.github.com/repos/${repo}`);
      if (!res.ok) {
        throw new Error('Failed to fetch GitHub stars');
      }
      const data = await res.json();
      return data.stargazers_count as number;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    refetchOnMount: 'always', // Override default to ensure fresh data
    retry: 1,
  });
};
